import { CARTON_REGEX } from "../../constants";
export default {
  regex: CARTON_REGEX,
  async docsRefsFromNumeroRastreo(db, paqueteria_numero_rastreo) {
    let _docs = {},
      qry = db
        .collection("cartons")
        .where("paqueteria_numero_rastreo", "==", paqueteria_numero_rastreo);
    let snap = await qry.get();
    
    if (!snap.docs.length) {
      qry = db
        .collection("cartons")
        .where("codigo_relacion", "==", paqueteria_numero_rastreo);
      snap = await qry.get();
    } 
    if(!snap.docs.length) {
      alert(
        "Código de paquete incorrecto ó no existen paquetes relacionados a esta guia: " +
          paqueteria_numero_rastreo
      );
    }
    snap.docs.forEach((doc) => {
      let cid = this.normalizeId(doc.id);
      let parsed = this.parse(cid, paqueteria_numero_rastreo);
      if (_docs[cid]) {
        let ev = [...(_docs[cid].eventos || []), ...(parsed.eventos || [])];
        let seen = new Set(),
          uniq = [];
        ev.forEach((e) => {
          let k = JSON.stringify([e.created_at, e.status, e.desc]);
          if (!seen.has(k)) {
            seen.add(k);
            uniq.push(e);
          }
        });
        _docs[cid].eventos = uniq;
      } else {
        _docs[cid] = parsed;
      }
    });
    return _docs;
  },
  parse(cartonId, paqueteria_numero_rastreo = null) {
    // Validar nomenclatura de codigo
    
    let regex = this.regex
    cartonId = cartonId.replaceAll("/", "-").toUpperCase();
      
    if (!regex.test(cartonId))
      throw new SyntaxError(
        "El identificador del paquete no cumple con la nomenclatura establecida."
      );

    // Nomenclatura de codigo
    // {job.dsforderid}&"-"& {job.ccmasterid}&"-"&  {cartoncontent.jobpart}     &"-"& {shipvia.syshipviaid}&"-"& {report_shippinglabel.cclqtythiscarton}  &"-"& {report_shippingLabel.cclcurrentlabel}&"-"& {report_shippingLabel.ccltotalcartons}&"-"&{jobshipment.ccshipmentid}&"-"&{cartoncontent.id}  

    let etiqueta = regex.exec(cartonId), carton;
    if(etiqueta[7].length){
      if (cartonId.startsWith("D")){
        etiqueta.splice(1,0,"");
      }
      // Nueva version de etiqueta
      carton = {
        dsforderid: etiqueta[1],
        ccmasterid: etiqueta[2],
        jobpart: etiqueta[3] || "",
        shipviaid: etiqueta[4],
        qtythiscarton: etiqueta[5] || 0,
        no_carton: etiqueta[6],
        total_cartons: etiqueta[7],
        shipmentid: etiqueta[8],
        cartoncontentid: etiqueta[9],
      };
    }
    else {
      // Si la etiqeuta es la version antigua
      carton = {
        dsforderid: etiqueta[1],
        ccmasterid: etiqueta[2],
        jobpart: etiqueta[3],
        shipviaid: etiqueta[4],
        no_carton: etiqueta[5],
        total_cartons: etiqueta[6],
      };
    }
    if (paqueteria_numero_rastreo)
      carton.paqueteria_numero_rastreo = paqueteria_numero_rastreo;
    console.log(cartonId, carton);
    return carton;
  },
  normalizeId(id) {
    return String(id).trim().replaceAll("/", "-").toUpperCase();
  },
  docRef(cartonId, db) {
    cartonId = this.normalizeId(cartonId);
    return db.collection("cartons").doc(cartonId);
  },
  backupDoc(carton) {
    if (location.hostname === "localhost") return;
    carton._id = carton._id.replaceAll("/", "-");
    // fetch(
    //   new Request("https://emprende.soltarimpresores.com/api/backup-carton", {
    //     method: "post",
    //     headers: new Headers({ "Content-Type": "application/json" }),
    //     body: JSON.stringify(carton),
    //   })
    // ).then(console.log);

  },
};
